var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"gl-footer"},[_c('div',{staticClass:"footer-wrap"},[_c('div',{staticClass:"content-wrap footer-block"},[_c('p',[_vm._v("指导单位："+_vm._s(_vm.setting.aboutUs)+" "),_c('span',{staticStyle:{"margin-left":"25px"}},[_vm._v("主办单位："+_vm._s(_vm.setting.contcatUs))])]),_c('p',[_vm._v("客服电话："+_vm._s(_vm.setting.copyright))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }